// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
//import { dispatchEvent } from 'fg-frontend/src/lib/dom';

const fragments = {
  TOGGLE: '[data-fragment="FulltextToggle.toggle"]',
  FORM_CONTAINER: '[data-fragment="FulltextToggle.formContainer"]',
  CONTAINER_CLOSE: '[data-fragment="FulltextToggle.formContainerClose"]',
  AUTOCOMPLETE_PLACEHOLDER: '[data-fragment="FulltextToggle.autocompletePlaceholder"]',
  //RESULTS_BTN_CONTAINER: '[data-fragment="FulltextToggle.resultsBtnContainer"]',
  //RESULTS_BTN: '[data-fragment="FulltextToggle.resultsBtn"]',
  CLEAR_INPUT: '[data-fragment="FulltextToggle.clearInput"]',
};

export default class FulltextHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleTouchOpen = this.handleTouchOpen.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleTouchClose = this.handleTouchClose.bind(this);
    this.handleTouchAutocomplete = this.handleTouchAutocomplete.bind(this);
    this.handleClose = this.handleClose.bind(this);
    //this.doSearch = this.doSearch.bind(this);
    this.doClear = this.doClear.bind(this);
    this.inputTyping = this.inputTyping.bind(this);
    this.observeFaAppearance = this.observeFaAppearance.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
  }

  didMount() {
    //check for touch devices
    function is_touch_enabled() {
      return ( 'ontouchstart' in window ) ||
        ( navigator.maxTouchPoints > 0 ) ||
        ( navigator.msMaxTouchPoints > 0 );
    }

    this.body = document.querySelector('body');
    this.fulltextHandler = this.element;
    this.queryValue = localStorage.getItem("fulltextQuery");
    this.fulltextToggle = this.fulltextHandler.querySelector(fragments.TOGGLE);
    this.formContainer = this.fulltextHandler.querySelector(fragments.FORM_CONTAINER);
    this.ftAutocomplete = this.fulltextHandler.querySelector('.fulltext-autocomplete');
    this.containerClose = this.fulltextHandler.querySelector(fragments.CONTAINER_CLOSE);
    this.autocompletePlaceholder = this.fulltextHandler.querySelector(fragments.AUTOCOMPLETE_PLACEHOLDER);
    this.clearInput = this.fulltextHandler.querySelector(fragments.CLEAR_INPUT);
    this.input = this.fulltextHandler.querySelector('.form-fulltext__input');
    this.query = this.formContainer.querySelector('.fulltext-header-query-container');
    this.submit = this.formContainer.querySelector('.form-fulltext__btn');
    this.appearanceObserver =  new MutationObserver(this.observeFaAppearance);
    this.form = this.fulltextHandler.querySelector('.form-fulltext');

    // Options for the observer (which mutations to observe)
    const observerConfig = {
      //attributes: true,
      childList: true,
      //subtree: false
    };

    if(this.fulltextHandler) {

      if(is_touch_enabled()){
        this.fulltextToggle.addEventListener('touchstart', this.handleTouchOpen);
        this.containerClose.addEventListener('touchstart', this.handleTouchClose);
      }else {
        this.fulltextToggle.addEventListener('click', this.handleOpen);
        window.addEventListener('click', function (){
          const fa = document.querySelector('.fulltext-autocomplete');
          if(fa){
            fa.classList.add('hidden');
          }
        })
      }

      this.containerClose.addEventListener('click', this.handleClose);
      this.input.addEventListener('input', this.inputTyping);
      this.clearInput.addEventListener('click', this.doClear);
      this.appearanceObserver.observe(this.query, observerConfig);
      this.form.addEventListener('submit', this.formSubmit);
    }
  }

  willUnMount() {}

  formSubmit = (e) => {
    // set searched value to local storage
    localStorage.setItem('fulltextQuery', this.input.value);
  };

  handleTouchOpen = (e) => {
    this.formContainer.classList.add('active');
    this.body.classList.add('fulltext--opened');
    this.autocompletePlaceholder.classList.add('ios-keyboard--on');
    this.input.autofocus = true;

    // create invisible dummy input to receive the focus first
    const fakeInput = document.createElement('input')
    fakeInput.setAttribute('type', 'text')
    fakeInput.style.position = 'absolute'
    fakeInput.style.opacity = 0
    fakeInput.style.height = 0
    fakeInput.style.fontSize = '16px' // disable auto zoom

    // you may need to append to another element depending on the browser's auto
    // zoom/scroll behavior
    document.body.prepend(fakeInput)

    // focus so that subsequent async focus will work
    fakeInput.focus()

    setTimeout(() => {
      const input =  document.getElementById('query');
      // now we can focus on the target input
      input.focus()

      // cleanup
      fakeInput.remove()

    }, 1000);

    if(this.queryValue && this.queryValue.length > 0) {
      this.clearInput.classList.remove('hidden');
      this.clearInput.classList.add('visible');
    }
  };

  handleTouchAutocomplete = (e) => {
    this.input.blur();
  };

  handleOpen = (e) => {
    this.formContainer.classList.add('active');
    document.querySelector('body').classList.add('active-fulltext');
  };

  handleTouchClose = (e) => {
    this.formContainer.classList.remove('active');
    this.doClear();
    this.autocompletePlaceholder.classList.remove('hidden');
    this.body.classList.remove('fulltext--opened');
    this.autocompletePlaceholder.classList.remove('ios-keyboard--on');
  };

  handleClose = (e) => {
    this.formContainer.classList.remove('active');
    document.querySelector('body').classList.remove('active-fulltext');
  };

  doClear = (e) => {
    this.input.value = "";
    this.clearInput.classList.add('hidden');
    this.input.classList.remove('active');
    this.input.focus();
  };

  inputTyping = (e) => {
    //alert(e.data);
    if(e.data){
     this.clearInput.classList.remove('hidden');
     this.clearInput.classList.add('visible');
     this.submit.classList.add('active');
    }
    this.input.classList.add('active');
    if(this.input.value == "") {
      this.clearInput.classList.add('hidden');
      this.input.classList.remove('active');
      this.submit.classList.remove('active');
    }
  };

  observeFaAppearance = (mutationsList, observer) => {
    for(let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const fulltextAutocomplete = document.querySelector('.fulltext-autocomplete');
        const faProductListing = document.querySelector('.fulltext-autocomplete__list--product');

        if(fulltextAutocomplete && fulltextAutocomplete.hasChildNodes()) {

          if(faProductListing && faProductListing.hasChildNodes()) {
            this.autocompletePlaceholder.classList.add('hidden');
          }else {
            this.autocompletePlaceholder.classList.remove('hidden');
          }

          if (fulltextAutocomplete){
            fulltextAutocomplete.addEventListener('touchmove', this.handleTouchAutocomplete);
          }
        }else {
          this.autocompletePlaceholder.classList.remove('hidden');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FulltextHandler.js